<template>
  <div class="spiag" :style="{ '--base-color': $theme.basecolor, '--base-dark': $theme.basedark, '--base-light': $theme.baselight }">
    <div v-if="errore" class="spiag-card shadow spiag-messaggio">
      <fa :icon="['fas', 'exclamation-triangle']" class="spiag-icona-grande" />
      <div>{{ t(errore) }}</div>
    </div>
    <div v-else-if="p" class="spiag-card shadow spiag-messaggio">
      <fa :icon="['fas', p.stato === 'A' ? 'times-circle' : 'umbrella-beach']" class="spiag-icona-grande" />
      <h2 v-if="p.stato === 'A'">{{ t("SPIA_Annullata") }}</h2>
      <h2 v-else-if="p.annullabile">{{ t("SPIA_AnnullaDomanda") }}</h2>
      <h2 v-else>{{ t("SPIA_NonAnnullabile") }}</h2>
      <div class="spiag-riepilogo">
        <div>
          <span>{{ t("SPIA_Nome") }}</span><b>{{ p.nome }}</b>
        </div>
        <div>
          <span>{{ t("SPIA_Periodo") }}</span><b>{{ periodoLungo(p.dal, p.al) }}</b>
        </div>
        <div>
          <span>{{ t("SPIA_Giorni") }}</span><b>{{ p.giorni }}</b>
        </div>
        <div>
          <span>{{ t("SPIA_Settore") }}</span><b>{{ p.settore }}</b>
        </div>
        <div v-if="p.fascia !== 'I'">
          <span>{{ t("SPIA_Fascia") }}</span><b>{{ t(p.fascia === "M" ? "SPIA_Mattina" : "SPIA_Pomeriggio") }}</b>
        </div>
        <div v-if="p.importo > 0">
          <span>{{ t("SPIA_Totale") }}</span><b>{{ prezzo(p.importo) }}</b>
        </div>
        <div v-if="p.stato !== 'A'">
          <span>&nbsp;</span><b>{{ t("SPIA_Stato_" + p.stato) }}</b>
        </div>
      </div>
      <!-- I posti li assegna il sistema già alla prenotazione: il banco li può cambiare, e il testo lo dice. -->
      <p v-if="p.stato !== 'A' && p.postiAssegnati" class="spiag-sub">{{ tv("SPIA_PostoAssegnato", { posti: p.postiAssegnati }) }}</p>
      <div v-if="p.stato !== 'A' && p.annullabile" class="spiag-btn" :class="{ disabilitato: invio }" @click="annulla">
        <fa v-if="invio" :icon="['fas', 'spinner']" spin />
        {{ t("SPIA_Annulla") }}
      </div>
    </div>
  </div>
</template>

<script>
import apiService from "../services/api";
import paginaService from "../services/pagina";

const LOCALI = { ita: "it-IT", ing: "en-GB", eng: "en-GB", ted: "de-DE", fra: "fr-FR", spa: "es-ES", por: "pt-PT", jap: "ja-JP" };

/**
 * Link dell'email: il cliente vede la sua prenotazione della spiaggia e la
 * annulla (/spiaggia/annulla?token=...). Il token dice struttura e prenotazione;
 * la lingua è quella in cui ha prenotato.
 *
 * Si mostrano il settore scelto e i posti che il sistema ha già assegnato alla
 * prenotazione (il banco li può cambiare), e lo stato: prenotata, confermata,
 * in corso, conclusa, non presentata o annullata.
 */
export default {
  data() {
    return {
      token: "",
      p: null,
      testi: {},
      errore: "",
      invio: false
    };
  },
  mounted() {
    paginaService.neutra(this);
    this.token = this.$route.query.token || "";
    apiService
      .get("BE_spiaggia/annulla?token=" + encodeURIComponent(this.token))
      .then((resp) => {
        this.testi = resp.testi || {};
        this.p = resp.prenotazione;
        this.$store.db = resp.db;
        this.$store.idhotel = resp.idhotel;
        this.$store.lang = String(this.p.lingua || "ita").toUpperCase();
        this.$root.$emit("lang:request", this.$store.lang);
        paginaService.applica(this, resp.grafica);
      })
      .catch((resp) => {
        this.testi = (resp && resp.testi) || {};
        this.errore = (resp && resp.errori && resp.errori[0]) || "SPIA_NonTrovata";
      });
  },
  methods: {
    t(chiave) {
      return this.testi[chiave] || chiave;
    },
    /** Testo con i segnaposto (%{posti}) sostituiti. */
    tv(chiave, valori) {
      let testo = this.t(chiave);
      Object.keys(valori || {}).forEach((k) => {
        testo = testo.split("%{" + k + "}").join(String(valori[k]));
      });
      return testo;
    },
    lingua() {
      return String((this.p && this.p.lingua) || "ita").toLowerCase();
    },
    prezzo(valore) {
      return new Intl.NumberFormat(LOCALI[this.lingua()] || "it-IT", { style: "currency", currency: "EUR" }).format(valore);
    },
    /** Il periodo per esteso: un giorno solo si scrive una volta. */
    periodoLungo(dal, al) {
      if (!dal) {
        return "";
      }
      if (!al || al === dal) {
        return this.dataLunga(dal);
      }
      return this.dataLunga(dal) + " – " + this.dataLunga(al);
    },
    dataLunga(sql) {
      const [a, m, g] = String(sql || "")
        .split("-")
        .map(Number);
      return a
        ? new Date(a, m - 1, g).toLocaleDateString(LOCALI[this.lingua()] || "it-IT", { day: "numeric", month: "long", year: "numeric" })
        : "";
    },
    annulla() {
      if (this.invio) {
        return;
      }
      this.invio = true;
      apiService
        .post("BE_spiaggia/annulla", { token: this.token })
        .then((resp) => {
          this.invio = false;
          this.p = resp.prenotazione;
        })
        .catch((resp) => {
          this.invio = false;
          this.errore = (resp && resp.errori && resp.errori[0]) || "ERR_GENERIC";
        });
    }
  }
};
</script>
